"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const Button_1 = __importDefault(require("../Button"));
const styles_1 = __importDefault(require("../../styles"));
exports.default = (0, mobx_react_1.observer)(({ form, controls = null }) => (react_1.default.createElement("div", { className: "tc tl-ns mt2" },
    (!controls || controls.onSubmit) &&
        react_1.default.createElement(Button_1.default, { type: "submit", className: styles_1.default.ctrl, onClick: form.onSubmit, content: (form.submitting || form.validating)
                ? react_1.default.createElement("b", null,
                    react_1.default.createElement("i", { className: "fa fa-spinner fa-spin" }))
                : react_1.default.createElement("b", null,
                    react_1.default.createElement("i", { className: "fa fa-dot-circle-o" }),
                    " Submit") }),
    (!controls || controls.onClear) &&
        react_1.default.createElement(Button_1.default, { text: 'Clear', icon: "eraser", className: styles_1.default.ctrl, onClick: form.onClear }),
    (!controls || controls.onReset) &&
        react_1.default.createElement(Button_1.default, { text: 'Reset', icon: "refresh", className: styles_1.default.ctrl, onClick: form.onReset }),
    react_1.default.createElement("div", { className: "f6 db red" }, form.error))));
